// extracted by mini-css-extract-plugin
export default {"customLabel":"dashboard_customLabel__LqDob"};